import React from "react";
import img1 from '../../assets/images/pexels-pixabay-534220.jpg';

const Detail = () => {
  return (
    <section className="relative pt-16 bg-blueGray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-start lg:items-center lg:justify-between gap-8">
          {/* Left Image + Quote Block */}
          <div className="w-full lg:w-5/12 xl:w-4/12">
            <div
              className="relative flex flex-col bg-white shadow-lg rounded-lg overflow-hidden"
              style={{ backgroundColor: 'deepskyblue' }}
            >
              <img
                alt="LABH Industries"
                src={img1}
                className="w-full object-cover h-auto rounded-t-lg"
                loading="lazy"
              />
              <blockquote className="relative p-8" style={{ backgroundColor: 'deepskyblue' }}>
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  className="absolute left-0 w-full block h-[95px] -top-[94px]"
                >
                  <polygon
                    points="-30,95 583,95 583,65"
                    className="text-blue-500 fill-current"
                  ></polygon>
                </svg>
                <h4 className="text-xl font-bold text-white">
                  Driven by Passion. Powered by Expertise.
                </h4>
                <p className="text-md font-light mt-2 text-white">
                  At LABH Industries, our strength lies in a passionate and expert workforce delivering world-class EPC solutions and equipment across industries with a strong commitment to quality, safety, and on-time delivery.
                </p>
              </blockquote>
            </div>
          </div>

          {/* Right Four Feature Blocks */}
          <div className="w-full lg:w-7/12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Block 1 */}
              <div className="flex flex-col bg-white shadow-sm rounded-lg p-5 h-full">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-4 shadow-md rounded-full bg-white">
                  <i className="fas fa-industry"></i>
                </div>
                <h6 className="text-lg font-semibold mb-2">
                  Complete EPC & Infrastructure Solutions
                </h6>
                <p className="text-blueGray-500 text-sm">
                  From modular fabrication and containerized structures to roads and buildings—our EPC services span every need, ensuring efficient project delivery.
                </p>
              </div>

              {/* Block 2 */}
              <div className="flex flex-col bg-white shadow-sm rounded-lg p-5 h-full">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-4 shadow-md rounded-full bg-white">
                  <i className="fas fa-shipping-fast"></i>
                </div>
                <h6 className="text-lg font-semibold mb-2">
                  Global Reach, Local Expertise
                </h6>
                <p className="text-blueGray-500 text-sm">
                  We handle export projects with precision—structural frame fabrication, packing, and seamless overseas delivery.
                </p>
              </div>

              {/* Block 3 */}
              <div className="flex flex-col bg-white shadow-sm rounded-lg p-5 h-full">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-4 shadow-md rounded-full bg-white">
                  <i className="fas fa-building"></i>
                </div>
                <h6 className="text-lg font-semibold mb-2">
                  Diverse Industry Applications
                </h6>
                <p className="text-blueGray-500 text-sm">
                  From factories and offices to hotels, institutions, hospitals, and supermarkets—our structures elevate infrastructure across all sectors.
                </p>
              </div>

              {/* Block 4 */}
              <div className="flex flex-col bg-white shadow-sm rounded-lg p-5 h-full">
                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-4 shadow-md rounded-full bg-white">
                  <i className="fas fa-tools"></i>
                </div>
                <h6 className="text-lg font-semibold mb-2">
                  One-Stop Integrated Services
                </h6>
                <p className="text-blueGray-500 text-sm">
                  With top-tier people, equipment, and infrastructure—we offer end-to-end solutions under one roof, making projects faster and smoother.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Detail;
